import { createFileRoute } from "@tanstack/react-router";
import { MessagesSquare } from "lucide-react";
import { EmptyState } from "@/components/empty-states/empty-state";

export const Route = createFileRoute("/_authenticated/$store/conversations/")({
  component: () => (
    <div className="flex flex-1 items-center justify-center">
      <EmptyState
        icon={MessagesSquare}
        title="Pick a conversation"
        description="Choose a seller on the left to see the transcript, Rogue's status and who's in control."
      />
    </div>
  ),
});
